export default __webpack_public_path__ + "static/char-v-20-4f1dc57a0d8641a805b12199967f96b4.mp4";